import { Link } from 'react-router-dom';
import { ArrowRight, Heart, Star, Sparkles, Award } from 'lucide-react';

const AboutPage = () => {
  const values = [
    {
      icon: Heart,
      title: 'Sevgi ilə',
      description: 'Hər bir məhsul böyük sevgi və həvəslə hazırlanır'
    },
    {
      icon: Star,
      title: 'Keyfiyyət',
      description: 'Yalnız ən yaxşı materiallar istifadə olunur'
    },
    {
      icon: Sparkles,
      title: 'Unikallıq',
      description: 'Hər əsər fərdi və təkrarolunmazdır'
    },
    {
      icon: Award,
      title: 'Təcrübə',
      description: '15 ildən çox sənətkarlıq təcrübəsi'
    }
  ];

  return (
    <div className="min-h-screen" data-testid="about-page">
      {/* Hero Section */}
      <section className="relative py-24 md:py-32 bg-gradient-to-br from-brand-primary via-[#E08E73] to-brand-gold overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://images.unsplash.com/photo-1683257199934-3a9822f37645?w=1600"
            alt="Texture"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center">
          <span className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Sparkles className="w-4 h-4" />
            Bizim hekayə
          </span>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white leading-tight">
            Əl işi sənətkarlığının<br />
            <span className="italic">incəlikləri</span>
          </h1>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-brand-primary text-sm font-medium uppercase tracking-wider">Turkan Rustamova</span>
              <h2 className="font-serif text-4xl md:text-5xl text-brand-brown mt-3">
                Ənənəvi sənətkarlıq,<br />
                <span className="text-brand-primary italic">müasir dizayn</span>
              </h2>
              <p className="mt-8 text-brand-muted leading-relaxed text-lg">
                Turkan Rustamova brendi 2008-ci ildən Azərbaycan əl işi sənətkarlığının 
                ən yaxşı ənənələrini yaşadır. Hər bir məhsulumuz ölkəmizin zəngin 
                mədəni irsindən ilham alaraq yaradılır.
              </p>
              <p className="mt-4 text-brand-muted leading-relaxed">
                Toxuma əl işlərindən başlayaraq, kuklalara və premium çantalara qədər 
                geniş çeşiddə məhsullarımız var. Hər biri fərdi sifarişlə hazırlanır 
                və müştərilərimizin istəklərinə uyğunlaşdırılır.
              </p>
              <p className="mt-4 text-brand-muted leading-relaxed">
                Biz inanırıq ki, əsl gözəllik detallarda gizlidir. Ona görə də hər 
                tikişə, hər rəngə, hər teksturaya xüsusi diqqət yetiririk.
              </p>
            </div>
            <div className="relative">
              <div className="aspect-square rounded-3xl overflow-hidden shadow-warm-lg">
                <img
                  src="https://images.unsplash.com/photo-1735414526681-ef9339138f65?w=800"
                  alt="Əl işi prosesi"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-8 -left-8 bg-brand-primary text-white rounded-2xl p-6 shadow-warm-lg">
                <p className="font-serif text-5xl">15+</p>
                <p className="text-white/80 mt-1">İllik təcrübə</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 md:py-28 bg-gradient-to-br from-brand-cream to-brand-accent/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-16">
            <span className="text-brand-primary text-sm font-medium uppercase tracking-wider">Dəyərlərimiz</span>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-brown mt-3">
              Bizim üçün ən vacib olanlar
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3xl p-8 shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2 text-center"
                data-testid={`value-${index}`}
              >
                <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-brand-primary to-[#E08E73] flex items-center justify-center">
                  <value.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-serif text-xl text-brand-brown mb-3">{value.title}</h3>
                <p className="text-brand-muted text-sm">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1 grid grid-cols-2 gap-4">
              <img
                src="https://images.unsplash.com/photo-1770637266187-60cf9d509593?w=400"
                alt="Çanta"
                className="rounded-2xl w-full h-64 object-cover shadow-warm"
              />
              <img
                src="https://images.unsplash.com/photo-1696414055568-a0a45684be06?w=400"
                alt="Kukla"
                className="rounded-2xl w-full h-64 object-cover shadow-warm mt-8"
              />
              <img
                src="https://images.unsplash.com/photo-1552335457-a3154a0beec3?w=400"
                alt="Toxuma"
                className="rounded-2xl w-full h-64 object-cover shadow-warm"
              />
              <img
                src="https://images.unsplash.com/photo-1643766883800-8b70a14e0bda?w=400"
                alt="Material"
                className="rounded-2xl w-full h-64 object-cover shadow-warm mt-8"
              />
            </div>
            <div className="order-1 lg:order-2">
              <span className="text-brand-primary text-sm font-medium uppercase tracking-wider">Proses</span>
              <h2 className="font-serif text-4xl md:text-5xl text-brand-brown mt-3">
                İdeyadan<br />
                <span className="text-brand-primary italic">hazır əsərə</span>
              </h2>
              <div className="mt-8 space-y-6">
                <div className="flex gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand-accent flex items-center justify-center text-brand-primary font-serif text-lg flex-shrink-0">1</div>
                  <div>
                    <h4 className="font-medium text-brand-brown">Dizayn və planlaşdırma</h4>
                    <p className="text-sm text-brand-muted mt-1">Müştəri istəklərinə uyğun konsept yaradılır</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand-accent flex items-center justify-center text-brand-primary font-serif text-lg flex-shrink-0">2</div>
                  <div>
                    <h4 className="font-medium text-brand-brown">Material seçimi</h4>
                    <p className="text-sm text-brand-muted mt-1">Ən yaxşı keyfiyyətli materiallar seçilir</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand-accent flex items-center justify-center text-brand-primary font-serif text-lg flex-shrink-0">3</div>
                  <div>
                    <h4 className="font-medium text-brand-brown">Əl ilə hazırlama</h4>
                    <p className="text-sm text-brand-muted mt-1">Hər detal əl ilə tikilib formalaşdırılır</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand-accent flex items-center justify-center text-brand-primary font-serif text-lg flex-shrink-0">4</div>
                  <div>
                    <h4 className="font-medium text-brand-brown">Keyfiyyət yoxlanışı</h4>
                    <p className="text-sm text-brand-muted mt-1">Son nəzarət və təhvil</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-28 bg-gradient-to-br from-brand-brown via-brand-brown to-brand-primary/80">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-white">
            Bizimlə əlaqə saxlayın
          </h2>
          <p className="mt-6 text-white/70 max-w-xl mx-auto text-lg">
            Sifariş vermək, suallarınızı soruşmaq və ya sadəcə söhbət etmək üçün
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-brown px-8 py-4 font-medium hover:shadow-lg hover:scale-105 transition-all duration-300"
              data-testid="about-cta-contact"
            >
              Əlaqə saxla
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/bags"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white text-white px-8 py-4 font-medium hover:bg-white/10 transition-all duration-300"
              data-testid="about-cta-collection"
            >
              Kolleksiyaya bax
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
